import { LoginOutput } from '@allocab/allocab-commons-shared-types';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { queryKeys } from '../services/datastore/queryKeys';
import { StorageManager } from '../services/storage/StorageManager';
import { clearTokens, TOKENS_STORAGE_KEY, updateTokens } from '../utils/auth';

const fetchTokens = () => StorageManager.getJSONItem<LoginOutput>(TOKENS_STORAGE_KEY);

export const useTokens = () => {
  const { data: tokens, isFetched } = useQuery(queryKeys.tokens(), fetchTokens, {
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  useEffect(() => {
    if (tokens !== undefined) {
      StorageManager.setJSONItem(TOKENS_STORAGE_KEY, tokens);
    }
  }, [tokens]);

  return { tokens, updateTokens, clearTokens, isFetched };
};
